import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";

function usePlacementsApi() {
  const { placementsApiClient } = useContext(AuthContext);
  return placementsApiClient;
}

export default usePlacementsApi;
